import parse from 'html-react-parser';
import styled from "styled-components";
import { BackButton, Image } from "../../_ui";
import labels from '../../../_translations/experts.json';
import store from "../../../_services/store";
import { COLORS } from "../../../constants";
import { useEffect } from 'react';
import { observer } from "mobx-react";

const fallbackSrc = '/images/symptom-no-photo.jpg';

const contributors = [
  {
    name: "Dr Vincent Sibaud",
    picture:
      "https://app-fr.one-smile.care/images/forwards/sections/forward12_section1025_photo0.jpeg",
    fonction:
      "Oncodermatologue, institut Universitaire du cancer , Toulouse Oncopole, France – Centre de lutte contre le cancer",
    spec: [
      "Expert international des toxicités dermatologiques des traitements anticancéreux - auteur de nombreux ouvrages et publications dans ce domaine",
      'Chairman de l’European Task Force "dermatology for cancer patients"',
    ],
    subtext:
      "<i><p>L'application <strong>S.O.S.</strong>, d&eacute;velopp&eacute;e par les Laboratoires dermatologiques Av&egrave;ne, a &eacute;t&eacute; con&ccedil;ue pour accompagner et former les professionnels de sant&eacute; dans la prise en charge et le conseil des patients souffrant de sympt&ocirc;mes dermatologiques li&eacute;s aux chimioth&eacute;rapies, th&eacute;rapies cibl&eacute;es, immunoth&eacute;rapie ou &agrave; la radioth&eacute;rapie.</p>\r\n<p>Avec cette application, vous pourrez :</p>\r\n<ul>\r\n<li>Apprendre &agrave; reconna&icirc;tre les principaux sympt&ocirc;mes et identifier les mol&eacute;cules inductrices</li>\r\n<li>Am&eacute;liorer la prise en charge de vos patients et leur qualit&eacute; de vie</li>\r\n<li>Tester vos connaissances gr&acirc;ce &agrave; de nombreux quiz et cas pratiques</li>\r\n<li>Etre inform&eacute; r&eacute;guli&egrave;rement sur les &eacute;volutions des nouveaux traitements et leurs effets ind&eacute;sirables</li>\r\n</ul></i>",
  },
  // {
  //   name: "Pr Caroline ROBERT",
  //   picture:
  //     "https://app-fr.one-smile.care/images/forwards/sections/forward12_section1024_photo0.jpeg",
  //   fonction: "Chef de service du département d’Oncodermatologie",
  //   spec: [
  //     "Oncodermatologue, Institut Gustave Roussy, Grand Paris, France – Centre de lutte contre le cancer",
  //     "Experte internationale du mélanome et des toxicités dermatologiques des traitements anticancéreux - auteure de nombreux ouvrages et publications dans ces domaines",
  //   ],
  // },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  //align-items: center;
  gap: 20px;
  padding: 20px;
  //margin: auto;
`;

const Card = styled.div`
  display: flex;
  max-width: 900px;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 20px;
  background: ${COLORS.WHITE};
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CardFonction = styled.p`
  color: ${COLORS.DARK};
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

const LabelName = styled.h3`
  color: ${COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const ExpertsPage = observer(() => {
  useEffect(() => {
    store.getExperts();
  }, []);

  // Afficher toutes les sections des experts
  const sections = store.expertsData?.map((section: any, i: number) => {
    return (
      <div key={`expert_section_${section.id || i}`} style={{ marginBottom: '40px' }}>
        <Card>
          {section.photos && section.photos.length > 0 && (
            <CardHeader>
              <Image 
                style={{ borderRadius: '50%' }} 
                src={section.photos[0].label} 
                width="100px" 
                height="100px" 
              />
              <div style={{ maxWidth: '400px', marginLeft: '20px' }}>
                <LabelName>{section.title}</LabelName>
              </div>
            </CardHeader>
          )}
          {parse(section.content || '<div></div>')}
        </Card>
      </div>
    )
  }) || [];

  return (
    <div className="fadeIn">
      <BackButton title={labels[store.currentLanguage].labels.contrib} />
      <Container>
        {sections}
      </Container>
    </div>
  )
})

export default ExpertsPage;